import React from 'react'

class Header extends React.Component {
  render() {
    return (<section id="header">
      <div className="inner">
        <img src="https://img.icons8.com/material/300/ECB7D3/labyrinth.png" alt="labyrinth" />
          <div className="titleText">
            <h1>Hello, I'm Kritapas Nimtrakul</h1>
            <h2>I'm a full-stack developer.</h2>
          </div>
        <ul className="actions">
          <li>
            <a href="#two" className="button scrolly">View my work</a>
          </li>
        </ul>
      </div>
    </section>)
  }
}

export default Header
